/**
 * LOP Texto y Productos — alinea altura del bloque de título entre las cards visibles del carrusel.
 * Mide altura natural (respetando line-clamp del tema); si todas son 1 línea, min-height = esa altura (sin hueco).
 * Si alguna usa 2 líneas, todas las visibles igualan el máximo para alinear precios debajo.
 */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  }

  function alignTitlesInSection(section) {
    var vp = section.querySelector('.theme-scroll--inner');
    var grid = section.querySelector('.products.carousel');
    if (!vp || !grid) return;

    var slides = grid.querySelectorAll('.carousel__slide');
    var pairs = [];
    var i;
    for (i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var card = slide.querySelector('product-card.product-card');
      if (!card) continue;
      var title = card.querySelector('.product-card-title');
      if (!title) continue;
      pairs.push({ slide: slide, title: title });
    }

    for (i = 0; i < pairs.length; i++) {
      pairs[i].title.style.minHeight = '';
    }

    var vr = vp.getBoundingClientRect();
    var visible = [];
    for (i = 0; i < pairs.length; i++) {
      var sr = pairs[i].slide.getBoundingClientRect();
      if (sr.right > vr.left + 1 && sr.left < vr.right - 1) {
        visible.push(pairs[i]);
      }
    }
    if (!visible.length) {
      visible = pairs.slice();
    }

    for (i = 0; i < visible.length; i++) {
      visible[i].title.classList.add('lop-tp-measure-title');
    }

    var maxH = 0;
    for (i = 0; i < visible.length; i++) {
      var h = visible[i].title.offsetHeight;
      if (h > maxH) maxH = h;
    }

    for (i = 0; i < visible.length; i++) {
      visible[i].title.classList.remove('lop-tp-measure-title');
    }

    for (i = 0; i < visible.length; i++) {
      visible[i].title.style.minHeight = maxH > 0 ? maxH + 'px' : '';
    }
  }

  function runAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list =
      scope.classList && scope.classList.contains('LOP-texto-productos')
        ? [scope]
        : scope.querySelectorAll('.LOP-texto-productos');
    var j;
    for (j = 0; j < list.length; j++) {
      alignTitlesInSection(list[j]);
    }
  }

  function schedule(root) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        runAll(root || document);
      });
    });
  }

  function bindSection(section) {
    if (!section || section.dataset.lopTpTitleAlignBound === 'true') return;
    section.dataset.lopTpTitleAlignBound = 'true';

    var vp = section.querySelector('.theme-scroll--inner');
    var grid = section.querySelector('.products.carousel');
    var debounced = debounce(function () {
      schedule(section);
    }, 100);

    if (vp) {
      vp.addEventListener('scroll', debounced, { passive: true });
    }

    window.addEventListener('resize', debounced);

    if (grid && typeof ResizeObserver !== 'undefined') {
      try {
        var ro = new ResizeObserver(debounced);
        ro.observe(grid);
      } catch (e) {}
    }

    schedule(section);
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections =
      scope.classList && scope.classList.contains('LOP-texto-productos')
        ? [scope]
        : scope.querySelectorAll('.LOP-texto-productos');
    var i;
    for (i = 0; i < sections.length; i++) {
      bindSection(sections[i]);
    }
  }

  function boot(root) {
    bindAll(root || document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        schedule(root || document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      boot(event.target);
    }
  });
})();
